var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4E7B89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.616 5.159c.067-.1.18-.159.301-.159h4.166c.121 0 .234.06.301.159l1.282 1.889h2.583c.464 0 .91.181 1.238.504.329.323.513.76.513 1.217v7.51c0 .456-.184.894-.513 1.217A1.767 1.767 0 0118.25 18H5.751c-.464 0-.91-.181-1.238-.504A1.707 1.707 0 014 16.279v-7.51c0-.456.184-.894.513-1.217a1.766 1.766 0 011.238-.504h2.583l1.282-1.89zm.495.553L8.83 7.602a.364.364 0 01-.302.158H5.751c-.272 0-.533.107-.726.296a1 1 0 00-.3.713v7.51a1 1 0 00.3.713c.193.19.454.296.726.296h12.498c.272 0 .533-.107.726-.296a1 1 0 00.3-.713v-7.51a1 1 0 00-.3-.713 1.035 1.035 0 00-.726-.296h-2.777a.364.364 0 01-.302-.158l-1.28-1.89h-3.78z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.692a2.308 2.308 0 100 4.616 2.308 2.308 0 000-4.616zM9 12a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "#fff"
  })));
}

export default SvgCamera;